import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openEditContact = asyncModalAdapter({
	upModalName: 'editContact',
	openModalName: 'EditContact',
	featureFlag: 'REACT_EDIT_CONTACT_MODAL',
	rejectOnEvent: true,
	rejectOnEmpty: true
});
